import { Fragment, useContext, useEffect, useState } from 'react';
import { Doughnut } from "react-chartjs-2";
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Row,
    Col,
    Container,
} from "reactstrap";
import Spinner from '../spinners/Spinner';
import AuthContext from '../../context/autenticacion/authContext';

// aqui solo aparece el responsive pequenho
// pantalla grande
//// responsive
const Div = styled.div`
    padding: 0rem !important;
    margin: 0.2rem 0rem 2.0rem 0rem !important;
    display: flex !important;
    flex-direction: row;
    justify-content: center;
    @media(min-width: 992px) {
        display: none !important;
        justify-content: center;
    }
`;

// pantalla grande
const DivModal = styled.div`
    display: none !important;
    flex-direction: row;
    @media(min-width: 992px) {
        display: flex !important;
    }
`;

/// aqui vamos a poner los estilos para el tap 
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const StyledTabs = (props) => <Tabs {...props} />;

const StyledTab = (props) => <Tab disableRipple {...props} />;

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

///// aqui vamos a poner la grafica 
const chart_pie_options = {
    maintainAspectRatio: true,
    legend: {
        display: true
    },
    tooltips: {
        backgroundColor: "#f5f5f5",
        titleFontColor: "#333",
        bodyFontColor: "#666",
        bodySpacing: 4,
        xPadding: 12,
        mode: "nearest",
        intersect: 0,
        position: "nearest"
    },
    responsive: true,
};

// Función para obtener datos del chart
const getChartData = (invertido, disponible) => {
    return {
        datasets: [
            {
                label: "Data",
                fill: true,
                backgroundColor: ['#e3a82b', '#171b24'],
                borderColor: ['#e3a82b', '#e3a82b'],
                borderWidth: 2,
                borderDash: [],
                borderDashOffset: 0.0,
                pointBackgroundColor: "#e3a82b",
                pointBorderColor: "rgba(255,255,255,0)",
                pointHoverBackgroundColor: "#e3a82b",
                pointBorderWidth: 20,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 15,
                pointRadius: 4,
                data: [parseFloat(invertido) || 0, parseFloat(disponible) || 0],
                weight: 300,
            }
        ],
        labels: ['Monto Invertido', 'Monto Disponible'],
    };
};

const ModalPrimario = ({ modalInfo, onSubmit, onChange, amount, open, handleClose, mensaje, cargando, guardarCargando, ApiLoad, apiload }) => {

    const authContext = useContext(AuthContext);

    const {
        TodosOferentes,
        TodosOfertas,
        TodosInversiones,
        TodosInversionesVendidas,
        TodosProyectosPrimario,
        TodosProyectosSecundario,
        Movimientos,
        Saldos,
        demo_status,
    } = authContext;

    const [modalpdf, guardarModalPdf] = useState(null);
    const [modalbro, guardarModalBro] = useState(null);

    useEffect(() => {
        guardarModalPdf(modalInfo?.pdf_oferente);
        guardarModalBro(modalInfo?.brouchure);
    }, [modalInfo?.pdf_oferente, modalInfo?.brouchure]);

    const guardar = cargando ? <Spinner /> : <Fragment>Invertir</Fragment>;

    const theme = useTheme();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const classes = useStyles();

    // Estado para los datos del chart
    const [chartData, setChartData] = useState({
        invertido: modalInfo?.percentage_investment || 0,
        disponible: modalInfo?.percentage_enable || 0
    });

    // Actualizar chartData cuando cambie modalInfo
    useEffect(() => {
        setChartData({
            invertido: modalInfo?.percentage_investment || 0,
            disponible: modalInfo?.percentage_enable || 0
        });
    }, [modalInfo?.percentage_investment, modalInfo?.percentage_enable]);

    const inversionminima = () => {
        let monto_minimo = 50;
        if (modalInfo?.disponible < 50)
            monto_minimo = modalInfo?.disponible;
        return monto_minimo;
    }

    // Datos del chart para pasar al componente Doughnut
    const chartPieData = getChartData(chartData.invertido, chartData.disponible);

    const handleCloseModal = () => {
        handleClose();
        guardarCargando(false);
        TodosOferentes();
        TodosOfertas();
        TodosInversiones();
        TodosInversionesVendidas();
        TodosProyectosPrimario();
        TodosProyectosSecundario();
        Movimientos();
        Saldos();
        ApiLoad();
        guardarModalPdf(null);
        guardarModalBro(null);
    };

    return (
        <Fragment>
            <Modal
                open={open}
                className="modal-responsive-fix-invertir"
            >
                <div className="card Modal-inversion invertir-fix-mobile m-0">
                    <form onSubmit={onSubmit}>
                        <CardHeader className="bg-modal-invertir ">
                            <Row>
                                <Col xs="10" sm="10" md="10" lg="10" className="btn-cancel-justify-center">
                                    <h3 className="title display-5 text-left my-4">Detalle de la inversión de {modalInfo?.name} {modalInfo?.nrocontrato}</h3>
                                </Col>
                                <Col xs="2" sm="2" md="2" lg="2" className="btn-cancel-justify-center">
                                    <div className="cancel-box-btn">
                                        <div className="cancel-btn-panther" onClick={() => {
                                            handleCloseModal();
                                        }}>
                                            <i className="tim-icons icon-simple-remove" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="min-height">
                            <Row className="mercado-style-primario">
                                <Col md="12">
                                    <p>Mercado primario </p>
                                </Col>
                            </Row>
                            <br />

                            {/* responsive start */}
                            <Div>
                                <div className="responsive-width-fix">
                                    <AppBar position="static" color="default" className="app-panther-bar">
                                        <StyledTabs
                                            value={value}
                                            onChange={handleChange}
                                            aria-label="styled tabs example"
                                            className="pr-0 pl-0 justify-content-center"
                                        >
                                            <StyledTab label="Datos de la Oferta" {...a11yProps(0)} />
                                            <StyledTab label="Distribucion" {...a11yProps(1)} />
                                            <StyledTab label="Saldo en la Cuenta" {...a11yProps(2)} />
                                        </StyledTabs>
                                    </AppBar>
                                    <SwipeableViews
                                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                        index={value}
                                        onChangeIndex={handleChangeIndex}
                                    >
                                        <TabPanel value={value} index={0} dir={theme.direction}>
                                            <Row>
                                                <Col sm="12">
                                                    <div className="m-0">
                                                        <CardHeader className="p-0">
                                                            <h5 className="title display-4">Datos de la Oferta</h5>
                                                            <p className="text-success border-success border-bottom pb-2"></p>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <div className="acc-config-panther">
                                                                <Container className="table-responsive">
                                                                    <Row>
                                                                        <Col xs="12" sm="12" className="align-items-center d-flex justify-content-center">
                                                                            <div className="col-11 my-4">
                                                                                <a href={`${modalInfo?.file}`} rel="noopener noreferrer" target="_blank">
                                                                                    <img src={modalInfo?.imagen} alt="Oferta" />
                                                                                </a>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs="6" sm="6">
                                                                            <ul className="pl-3">
                                                                                <li>Tipo de Oferta:<br /><strong>{modalInfo?.tipo}</strong></li>
                                                                                <li>Monto:<br /><strong>{modalInfo?.amount_proyecto} {demo_status === "active" ? 'USDT' : ' $ '}</strong></li>
                                                                                <li>Monto Invertido<br /><strong>{modalInfo?.amount_invertido} {demo_status === "active" ? 'USDT' : ' $ '}</strong></li>
                                                                                <li>Tasa de Interés:<br /><strong>{modalInfo?.tax_referential_client} %</strong></li>
                                                                                <li>Garantía:<br /><strong>{modalInfo?.warranty}</strong></li>
                                                                            </ul>
                                                                        </Col>
                                                                        <Col xs="6" sm="6">
                                                                            <ul className="pl-3">
                                                                                <li>Clasificación:<br /><strong>{modalInfo?.risk}</strong></li>
                                                                                <li>Fecha de Rendimiento:<br /><strong>{modalInfo?.end_date}</strong></li>
                                                                                <li>Tiempo Total de Contrato<br /><strong>{modalInfo?.dias} d.</strong></li>
                                                                                <li>Tiempo Restante de Contrato<strong>{modalInfo?.tiemporemanente} d.</strong></li>
                                                                            </ul>
                                                                        </Col>
                                                                    </Row>
                                                                </Container>
                                                                <div className="imagen-mis-inversiones-fix-dos">
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <p className="title display-5 text-left my-1">Nombre de la oferta : <br /> {modalInfo?.name}</p>
                                                                        </div>
                                                                        <p className="w-100 container">
                                                                            <strong>Descripción:</strong><br />
                                                                            {modalInfo?.description}
                                                                        </p>
                                                                        <div className={modalpdf === "" || modalpdf === null || modalpdf === "null" || modalpdf === 'null' ? 'd-none col-6' : 'd-block col-6'}>
                                                                            <a href={`${modalInfo?.pdf_oferente}`} rel="noopener noreferrer" target="_blank">
                                                                                <button
                                                                                    color="link"
                                                                                    title=""
                                                                                    type="button"
                                                                                    className="btn btn-primario btn-block btn-radius-panther-dos btn-panther-power-sm-green mt-1"
                                                                                >
                                                                                    Datos de oferta
                                                                                </button>
                                                                            </a>
                                                                        </div>
                                                                        <div className={modalbro === " " || modalbro === null || modalbro === "null" || modalbro === 'null' ? 'd-none col-6 mb-3' : 'd-block col-6 mb-3'}>
                                                                            <a href={`${modalInfo?.brouchure}`} rel="noopener noreferrer" target="_blank">
                                                                                <button
                                                                                    color="link"
                                                                                    title=""
                                                                                    type="button"
                                                                                    className="btn btn-primario btn-block btn-radius-panther-dos btn-panther-power-sm-green mt-1"
                                                                                >
                                                                                    Catálogo
                                                                                </button>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                        <CardFooter className="d-flex justify-content-end flex-direction-collumn-panther">
                                                            <h3 className="text-left m-0">Estás a punto de invertir</h3>
                                                            <label>Click para continuar al paso final</label>
                                                            <div className="btn btn-radius mt-2 btn-invertir btn-block" onClick={() => setValue(2)}>
                                                                Invertir
                                                            </div>
                                                        </CardFooter>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </TabPanel>

                                        <TabPanel value={value} index={1} dir={theme.direction}>
                                            <Row>
                                                <Col sm="12">
                                                    <div className="m-0">
                                                        <CardHeader className="p-0">
                                                            <h5 className="title display-4">Distribución del contrato</h5>
                                                            <p className="text-success border-success border-bottom pb-2"></p>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <Col md="12">
                                                                <div className="kyc-containDer">
                                                                    <CardBody className="p-0">
                                                                        <div className="chart-area">
                                                                            <Doughnut
                                                                                data={chartPieData}
                                                                                options={chart_pie_options}
                                                                                className="doughnut-style"
                                                                            />
                                                                        </div>
                                                                    </CardBody>
                                                                </div>
                                                            </Col>
                                                        </CardBody>
                                                        <CardFooter className="d-flex justify-content-center distribucion-contrato-footer">
                                                            <div className="row d-flex acc-config-panther justify-content-center width-100">
                                                                <div className="col-6">
                                                                    <ul>
                                                                        <li className="text-center">{modalInfo?.amount_invertido} {demo_status === "active" ? 'USDT' : ' $ '}</li>
                                                                        <li className="text-center distribucion-contrato-footer-title">{modalInfo?.percentage_investment} %</li>
                                                                        <li className="text-center">Monto Invertido</li>
                                                                    </ul>
                                                                </div>
                                                                <div className="col-6">
                                                                    <ul>
                                                                        <li className="text-center">{modalInfo?.disponible} {demo_status === "active" ? 'USDT' : ' $ '}</li>
                                                                        <li className="text-center distribucion-contrato-footer-title">{modalInfo?.percentage_enable} %</li>
                                                                        <li className="text-center">Monto Disponible</li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </CardFooter>
                                                        <CardFooter className="d-flex justify-content-end flex-direction-collumn-panther">
                                                            <h3 className="text-left m-0">Estás a punto de invertir</h3>
                                                            <label>Click para continuar al paso final</label>
                                                            <div className="btn btn-radius mt-2 btn-invertir btn-block" onClick={() => setValue(2)}>
                                                                Invertir
                                                            </div>
                                                        </CardFooter>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </TabPanel>

                                        <TabPanel value={value} index={2} dir={theme.direction}>
                                            <Row>
                                                <Col sm="12">
                                                    <div className="invertir-fx m-0">
                                                        <CardHeader className="p-0">
                                                            <h5 className="title display-4">Saldo en la cuenta</h5>
                                                            <p className="text-success border-success border-bottom pb-2"></p>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <div className="acc-config-panther">
                                                                <ul>
                                                                    <h3 className="text-left m-0">Saldo disponible</h3>
                                                                    <p className="text-success border-success border-bottom text-right font-disponible">{modalInfo?.disponiblewallet}</p>
                                                                    <h3 className="text-left m-0">Monto a invertir</h3>
                                                                    <label htmlFor="amount">Digite el monto a invertir</label>
                                                                    <input
                                                                        type="number"
                                                                        id="amount"
                                                                        name="amount"
                                                                        placeholder={demo_status === "active" ? 'USDT' : 'USDT'}
                                                                        onChange={onChange}
                                                                        min={inversionminima()}
                                                                        step="0.01"
                                                                        value={amount}
                                                                        className="btn-block display-4 text-center input-invertir"
                                                                    />
                                                                    <li className="display-4">Ganancia:</li>
                                                                    <li className="text-right m-0 p-1">{modalInfo?.ganancia} %</li>
                                                                    <li className="display-4">Valor a recibir:</li>
                                                                    <li className="text-right m-0 p-1"><p id="totalarecibir">0</p></li>
                                                                </ul>
                                                            </div>
                                                        </CardBody>
                                                        <CardFooter className="d-flex justify-content-end">
                                                            <Button type="submit" className="btn-invertir btn-block">
                                                                {guardar}
                                                            </Button>
                                                        </CardFooter>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </TabPanel>
                                    </SwipeableViews>
                                </div>
                            </Div>

                            {/* responsive end */}
                            <DivModal>
                                <Col sm="12" md="4">
                                    <Card className="card">
                                        <CardHeader>
                                            <h5 className="title display-4">Datos de la Oferta</h5>
                                            <p className="text-success border-success border-bottom pb-2"></p>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="acc-config-panther mb-0">
                                                <ul>
                                                    <li>Tipo de Oferta:<strong>{modalInfo?.tipo}</strong></li>
                                                    <li>Monto:<strong>{modalInfo?.amount_proyecto} {demo_status === "active" ? 'USDT' : ' $ '}</strong></li>
                                                    <li>Monto Invertido<strong>{modalInfo?.amount_invertido} {demo_status === "active" ? 'USDT' : ' $ '}</strong></li>
                                                    <li>Tasa de Interés:<strong>{modalInfo?.tax_referential_client} %</strong></li>
                                                    <li>Garantía:<strong>{modalInfo?.warranty}</strong></li>
                                                    <li>Clasificación:<strong>{modalInfo?.risk}</strong></li>
                                                    <li>Fecha de Rendimiento:<strong>{modalInfo?.end_date}</strong></li>
                                                    <li>Tiempo Total de Contrato<strong>{modalInfo?.dias} d.</strong></li>
                                                    <li>Tiempo Restante de Contrato:<strong>{modalInfo?.tiemporemanente} d.</strong></li>
                                                </ul>
                                                <div className="imagen-mis-inversiones-fix-dos">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <p className="title display-5 text-left my-1">Nombre de la oferta : <br /> {modalInfo?.name}</p>
                                                        </div>
                                                        <p className="w-100 container">
                                                            <strong>Descripción:</strong><br />
                                                            {modalInfo?.description}
                                                        </p>
                                                        <div className={modalpdf === "" || modalpdf === null || modalpdf === "null" || modalpdf === 'null' ? 'd-none col-6' : 'd-block col-6'}>
                                                            <a href={`${modalInfo?.pdf_oferente}`} rel="noopener noreferrer" target="_blank">
                                                                <button
                                                                    color="link"
                                                                    title=""
                                                                    type="button"
                                                                    className="btn btn-primario btn-block btn-radius-panther-dos btn-panther-power-sm-green mt-1"
                                                                >
                                                                    Datos de oferta
                                                                </button>
                                                            </a>
                                                        </div>
                                                        <div className={modalbro === " " || modalbro === null || modalbro === "null" || modalbro === 'null' ? 'd-none col-6 mb-3' : 'd-block col-6 mb-3'}>
                                                            <a href={`${modalInfo?.brouchure}`} rel="noopener noreferrer" target="_blank">
                                                                <button
                                                                    color="link"
                                                                    title=""
                                                                    type="button"
                                                                    className="btn btn-primario btn-block btn-radius-panther-dos btn-panther-power-sm-green mt-1"
                                                                >
                                                                    Catálogo
                                                                </button>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                <Col sm="12" md="4">
                                    <Card className="card">
                                        <CardHeader>
                                            <h5 className="title display-4">Distribución del contrato</h5>
                                            <p className="text-success border-success border-bottom pb-2"></p>
                                        </CardHeader>
                                        <CardBody>
                                            <Col md="12">
                                                <div className="kyc-containDer">
                                                    <CardBody className="p-0">
                                                        <div className="chart-area">
                                                            <Doughnut
                                                                data={chartPieData}
                                                                options={chart_pie_options}
                                                                className="doughnut-style"
                                                            />
                                                        </div>
                                                    </CardBody>
                                                </div>
                                            </Col>
                                        </CardBody>
                                        <CardFooter className="d-flex justify-content-center distribucion-contrato-footer">
                                            <div className="row d-flex acc-config-panther justify-content-center width-100">
                                                <div className="col-6">
                                                    <ul>
                                                        <li className="text-center">{modalInfo?.amount_invertido} {demo_status === "active" ? 'USDT' : ' $ '}</li>
                                                        <li className="text-center distribucion-contrato-footer-title">{modalInfo?.percentage_investment} %</li>
                                                        <li className="text-center">Monto Invertido</li>
                                                    </ul>
                                                </div>
                                                <div className="col-6">
                                                    <ul>
                                                        <li className="text-center">{modalInfo?.disponible} {demo_status === "active" ? 'USDT' : ' $ '}</li>
                                                        <li className="text-center distribucion-contrato-footer-title">{modalInfo?.percentage_enable} %</li>
                                                        <li className="text-center">Monto Disponible</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </Col>

                                <Col sm="12" md="4">
                                    <Card className="card invertir-fx">
                                        <CardHeader>
                                            <h5 className="title display-4">Saldo en la cuenta</h5>
                                            <p className="text-success border-success border-bottom pb-2"></p>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="acc-config-panther">
                                                <ul>
                                                    <h3 className="text-left m-0">Saldo disponible</h3>
                                                    <p className="text-success border-success border-bottom text-right font-disponible">{modalInfo?.disponiblewallet}</p>
                                                    <h3 className="text-left m-0">Monto a invertir</h3>
                                                    <label htmlFor="amount">Digite el monto a invertir</label>
                                                    <input
                                                        type="number"
                                                        id="amount"
                                                        name="amount"
                                                        placeholder={demo_status === "active" ? 'USDT' : 'USDT'}
                                                        onChange={onChange}
                                                        min={inversionminima()}
                                                        step="0.01"
                                                        value={amount}
                                                        className="btn-block display-4 text-center input-invertir"
                                                    />
                                                    <li className="display-4">Ganancia:</li>
                                                    <li className="text-right m-0 p-1">{modalInfo?.ganancia} %</li>
                                                    <li className="display-4">Valor a recibir:</li>
                                                    <li className="text-right m-0 p-1"><p id="totalarecibir">0</p></li>
                                                </ul>
                                            </div>
                                        </CardBody>
                                        <CardFooter className="d-flex justify-content-end">
                                            <Button type="submit" className="btn-invertir btn-block">
                                                {guardar}
                                            </Button>
                                        </CardFooter>
                                    </Card>
                                </Col>
                            </DivModal>

                            {/* Mensaje Modal */}
                            {mensaje ?
                                <Modal
                                    className={classes.modal}
                                    open={open}
                                    onClose={handleClose}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 900,
                                    }}
                                >
                                    <Fade in={open} timeout={154} onClose={handleClose}>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-12 d-flex justify-content-center">
                                                    <div className={`card ${classes.paper} Modal-inversion modal-power-up modal-power-up-profile`}>
                                                        <CardBody>
                                                            <Row className="d-flex justify-content-center">
                                                                <Col sm="12" md="6">
                                                                    <p className="text-center display-4 title font-light-weight-modal">{mensaje}</p>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <div className="row">
                                                                <div className="col-4"></div>
                                                                <div className="col-4">
                                                                    <button
                                                                        className="btn mt-0 btn-block btn-info"
                                                                        onClick={handleCloseModal}
                                                                    >
                                                                        Aceptar
                                                                    </button>
                                                                </div>
                                                                <div className="col-4"></div>
                                                            </div>
                                                        </CardFooter>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Fade>
                                </Modal>
                                : null}
                        </CardBody>
                    </form>
                </div>
            </Modal>
        </Fragment>
    );
}

export default ModalPrimario;